import { createContext, useContext, useMemo, useState } from 'react'
import type { TabsContextState, TabsProps } from './types'

const TabsContext = createContext<TabsContextState>({} as TabsContextState)

export const Tabs: React.FC<React.PropsWithChildren<TabsProps>> = ({
  children,
  id,
}) => {
  const [activeTab, setActiveTab] = useState<number | undefined>(0)

  const context = useMemo<TabsContextState>(
    () => ({
      id,
      activeTab,
      setActiveTab,
    }),
    [id, activeTab],
  )

  return <TabsContext.Provider value={context}>{children}</TabsContext.Provider>
}

export const useTabsContext = () => useContext(TabsContext)
